export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7425.915b9e27.jpg";